import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'hoursConverter' })
export class HoursConverterPipe implements PipeTransform {
    transform(value, args: string[]): any {
        let hours = (value / 360).toFixed(2);

        return hours;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/pipes/hoursConverter.pipe.ts